import script from "./movable.vue?vue&type=script&lang=js"
export * from "./movable.vue?vue&type=script&lang=js"

import "./movable.vue?vue&type=style&index=0&id=e84822aa&lang=css"

const __exports__ = script;

export default __exports__